import { useEffect, useState } from "react"
import { BillingView } from "../../views"
import { BillingService } from "../../../services"
import moment from "moment"

const INVOICES_PAGE_SIZE = 10

const BillingAction = () => {
  const url = process.env.REACT_APP_ETICKET_API
  const billingService = new BillingService(url)
  const token = JSON.parse(localStorage.getItem('token')).accessToken

  const [isLoading, setIsLoading] = useState(true)
  const [billingSummary, setBillingSummary] = useState(null)
  const [monthlyConsumption, setMonthlyConsumption] = useState(null)
  const [billingInvoices, setBillingInvoices] = useState(null)
  const [billingCycleModelUsage, setBillingCycleModelUsage] = useState(null)
  const [billingCycleBotUsage, setBillingCycleBotUsage] = useState(null)

  const getData = async () => {
    try {
      setIsLoading(true)
      const now = moment()
      const [
        billingSummaryP,
        monthlyConsumptionP,
        billingInvoicesP,
        billingCycleModelUsageP,
        billingCycleBotUsageP
      ] = await Promise.all([
        billingService.getBillingSummary(now.format('YYYY'), now.format('M'), token),
        billingService.getBillingMonthlyConsumption(now.format('YYYY'), token),
        billingService.getBillingInvoices(1, INVOICES_PAGE_SIZE, token),
        billingService.getBillingCycleModelUsage(token),
        billingService.getBillingCycleBotUsage(token)
      ])
      setBillingSummary(billingSummaryP)
      setMonthlyConsumption(monthlyConsumptionP)
      setBillingInvoices(billingInvoicesP)
      setBillingCycleModelUsage(billingCycleModelUsageP)
      setBillingCycleBotUsage(billingCycleBotUsageP)
    } catch (e) {
      console.error(`An error occurred fetching billing data: ${e}`)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <BillingView
      isLoading={isLoading}
      billingSummary={billingSummary}
      monthlyConsumption={monthlyConsumption}
      billingInvoices={billingInvoices}
      billingCycleModelUsage={billingCycleModelUsage}
      billingCycleBotUsage={billingCycleBotUsage}
    />
  )
}

export { BillingAction as default }
